import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './index.css';

const Footer = () => {
  return (
    <div className="footer-container">
      <Container>
        <Row className="pt-3">
          <Col className="text-white-50 " xs={{ span: 6 }} md={{ span: 6 }}>
            <div className="d-flex flex-column">
              <span className="footer-font"> ESP. </span>
              <span> Eclipse Software Project </span>
              <span> 2021 </span>
            </div>
          </Col>
          <Col className="text-white-50" xs={{ span: 6 }} md={{ span: 6 }}>
            <div className="d-flex flex-column">
              <span>
                <b>Information</b>
              </span>
              <span className="footer-font-info"> About </span>
              <span className="footer-font-info"> Terms </span>
              <span className="footer-font-info"> Social </span>
              <span className="footer-font-info"> Contact </span>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <div className="col-12 footer-font-info text-center">
            <div>
              © 2021 Software Project Laboratory Assistant Informatika Unpad
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
